import React, { useState, useEffect } from "react";
import "./tableStyle.css";
import { getUserList } from "../../Services/Services";
import { Col, Input, Button, Form } from "antd";
import AddNewLifter from "./AddNewLifter";
import LifterUpdate from "./LifterUpdate";
import Header from "../Header-Footer/Header";
import * as XLSX from "xlsx";
import Footer from "../Header-Footer/Footer";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { FaFilePdf, FaFileExcel } from "react-icons/fa";
export default function Lifter() {
  const [userList, setuserList] = useState([]);
  const [userDetails, setuserDetails] = useState([]);
  const [form] = Form.useForm();
  useEffect(() => {
    GetUserList();
  }, []);

  const GetUserList = async () => {
    const response = await getUserList();
    const filterData = response.filter(
      (o) =>
        o.user_type === "Lifter" &&
        o.com_name === localStorage.getItem("com_name")
    );
    if (filterData) {
      const sortedArray = [...filterData].sort((a, b) => b.id - a.id);
      setuserList(sortedArray);
      setuserDetails(sortedArray);
    }
  };
  const handleValuesChange = (changedValues, allValues) => {
    const filteredData = userDetails.filter(
      (item) =>
        item.name
          .toLowerCase()
          .includes((allValues.name || "").toLowerCase()) &&
        item.pan_no
          .toLowerCase()
          .includes((allValues.pan_no || "").toLowerCase())
    );

    setuserList(filteredData);
  };

  const handleExportToExcel = () => {
    const workbook = XLSX.utils.book_new();
    const wsData = userList.map((e, index) => [
      index + 1,
      e.name,
      e.email,
      e.contact_no,
      e.gst_no,
      e.pan_no,
      e.Address,
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      ["Sr. No", "Lifter Name", "Email", "Contact No.", "Gst No", "Pan No"],
      ...wsData,
    ]);

    XLSX.utils.book_append_sheet(workbook, worksheet, "userList");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, "Lifter List.xlsx");
  };
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const [lifterData, setLifterData] = useState();
  const findLifter = (id) => {
    setLifterData(userList.find((o) => o.id === id));
  };
  return (
    <div style={{ height: "90vh" }}>
      <Header heading="LIFTER VIEW" />
      <Form form={form} layout="vertical" onValuesChange={handleValuesChange}>
        <div
          className=" grid grid-cols-1 sm:grid sm:grid-cols-3 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%]"
          style={{ marginBottom: "10px" }}
        >
          <Col>
            <label>
              <b>Search Lifter User Name</b>
            </label>
            <br />
            <Form.Item name="name">
              <Input placeholder="Search by Lifter Name" />
            </Form.Item>
          </Col>
          <Col>
            <label>
              <b>Pan Number</b>
            </label>
            <br />
            <Form.Item name="pan_no">
              <Input placeholder="Search by Pan Number" />
            </Form.Item>
          </Col>
          <Col>
            <AddNewLifter
              setuserList={setuserList}
              setuserDetails={setuserDetails}
            />
            <Button
              style={{
                top: "13px",
                margin: "10px",
                backgroundColor: "black",
                color: "white",
                fontWeight: "600",
              }}
              onClick={handlePrint}
            >
              <FaFilePdf />
            </Button>
            <Button
              style={{
                top: "13px",
                margin: "10px",
                backgroundColor: "green",
                color: "white",
                fontWeight: "600",
              }}
              onClick={handleExportToExcel}
            >
              <FaFileExcel />
            </Button>
          </Col>
        </div>
      </Form>
      <div className="table-wrapper" ref={componentRef} style={{ maxHeight: "480px", overflowX: "auto", overflowY: "auto" }}>
        <table id="my-table" className="w-full relative">
          <thead className="bg-[#151B54] w-full text-white">
            <tr>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Sr. No
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                Id
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                Lifter Name
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Email
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                Contact No
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                Gst No
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                Pan No
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {userList.map((e, index) => (
              <tr key={e.client_id}>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {index + 1}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.id}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.name}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.email}
                </td>
                {/* <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.password}</td> */}
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.contact_no}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.gst_no}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.pan_no}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  <button onClick={() => findLifter(e.id)}>
                    <LifterUpdate
                      setuserList={setuserList}
                      setuserDetails={setuserDetails}
                      lifterData={lifterData}
                    />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* <Footer /> */}
      </div>
    </div>
  );
}
